import * as React from "react"
import { Eye } from "lucide-react"
import { cn } from "./utils"
import { Input } from "./input"

export interface PasswordInputProps
  extends React.InputHTMLAttributes<HTMLInputElement> {}

const PasswordInput = React.forwardRef<HTMLInputElement, PasswordInputProps>(
  ({ className, ...props }, ref) => {
    const [showPassword, setShowPassword] = React.useState(false)

    return (
      <div className="relative">
        <Input
          type={showPassword ? "text" : "password"}
          className={cn("pr-10", className)}
          ref={ref}
          {...props}
        />
        <button
          type="button"
          onClick={() => setShowPassword(!showPassword)}
          className="absolute right-0 top-0 h-full px-3 py-2 hover:bg-transparent"
          tabIndex={-1}
          aria-label={showPassword ? "Hide password" : "Show password"}
        >
          <Eye 
            className={cn(
              "h-4 w-4 transition-colors",
              showPassword 
                ? "text-gray-700 hover:text-gray-900" 
                : "text-gray-300 hover:text-gray-400"
            )}
          />
        </button>
      </div>
    )
  }
)
PasswordInput.displayName = "PasswordInput"

export { PasswordInput }